<template>
<div class="lp-player" id="lp-player" tabindex="0">
  <!-- Start immer mit Black-Hold, bis die Client-Init-Logik entschieden hat -->
    <div class="lp-waiting" id="lp-waiting" style="display:none; background-color:#000000;">
    <img class="lp-waiting-logo" id="lp-waiting-logo" src="" alt="" style="display:none;">
    <div class="lp-waiting-overlay" id="lp-waiting-overlay"></div>
    <div class="lp-waiting-content">
      <div class="lp-waiting-text" id="lp-waiting-text"></div>
      <div class="lp-waiting-cd" id="lp-waiting-cd" style="display:none;">
        <div class="lp-waiting-cd-label" id="lp-waiting-cd-label"></div>
        <div class="lp-waiting-cd-timer" id="lp-waiting-cd-timer"></div>
      </div>
    </div>
  </div>
  <div class="lp-preroll" id="lp-preroll" style="display:none;">
    <video id="lp-preroll-video" playsinline preload="metadata"></video>
    
    <!-- Click-to-Play Overlay -->
    <div class="lp-preroll-play-overlay" id="lp-preroll-play-overlay" style="display:none;">
      <div class="play-circle">
        <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>
      </div>
    </div>
    
    <!-- Pre-Roll Control Bar -->
    <div class="lp-preroll-bar" id="lp-preroll-bar" style="display:none;">
      <!-- LINKS: Play, Mute, Volume -->
      <button class="lp-btn" id="lp-preroll-play" title="Play/Pause">
        <svg viewBox="0 0 24 24"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" fill="currentColor"/></svg>
      </button>
      <button class="lp-btn" id="lp-preroll-mute" title="Stumm/Laut">
        <svg viewBox="0 0 24 24" id="lp-preroll-vol-icon"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" fill="currentColor"/></svg>
      </button>
      <input type="range" class="lp-preroll-vol-slider" id="lp-preroll-volume" min="0" max="100" value="80">
      
      <!-- MITTE: Spacer -->
      <div class="lp-spacer"></div>
      
      <!-- RECHTS: Fullscreen -->
      <button class="lp-btn" id="lp-preroll-fs" title="Vollbild">
        <svg viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" fill="currentColor"/></svg>
      </button>
    </div>
    
    <!-- Skip Button - SEPARAT (immer sichtbar) -->
    <div class="lp-preroll-skip-wrap" id="lp-preroll-skip-wrap" style="display:none;">
      <button class="lp-preroll-skip-btn" id="lp-preroll-skip" disabled>
        <span id="lp-skip-text">5s</span>
      </button>
    </div>
  </div>
  <div class="lp-video" id="lp-video" style="display:none; visibility:hidden;"></div>
  <div class="lp-bar" style="display:none;">
    <button class="lp-btn" id="lp-play" title="Play/Pause">
      <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
    </button>
    <div class="lp-vol">
      <button class="lp-btn" id="lp-mute" title="Stumm">
        <svg viewBox="0 0 24 24" id="lp-vol-icon"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>
      </button>
      <input type="range" id="lp-volume" min="0" max="100" value="80" title="Lautstärke">
    </div>
    <div class="lp-src" id="lp-sources" style="display:none">
      <button id="lp-src-webrtc" class="on">WebRTC</button>
      <button id="lp-src-hls">LL-HLS</button>
    </div>
    <select class="lp-select" id="lp-quality" style="display:none">
      <option value="auto">Automatisch</option>
    </select>
    <div class="lp-spacer"></div>
    <div class="lp-live" id="lp-live"><span class="lp-live-dot"></span><span>LIVE</span></div>
    <button class="lp-btn" id="lp-fs" title="Vollbild">
      <svg viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>
    </button>
  </div>
</div>
</template>

<script>
/* eslint-disable */
// Diese Komponente bindet den vom Streaming-Anbieter (m-eventtechnik.ch) gelieferten
// Player unverändert ein (HTML/CSS/JS als Einheit geliefert). Bewusst kein Refactoring/
// Linting des Drittanbieter-Codes, um das Verhalten exakt zu erhalten.
function loadScriptOnce(src) {
  return new Promise((resolve, reject) => {
    if (document.querySelector('script[data-stream-player-src="' + src + '"]')) {
      resolve();
      return;
    }
    const el = document.createElement('script');
    el.src = src;
    el.async = true;
    el.dataset.streamPlayerSrc = src;
    el.onload = () => resolve();
    el.onerror = () => reject(new Error('Konnte Skript nicht laden: ' + src));
    document.head.appendChild(el);
  });
}

export default {
  name: 'StreamPlayer',
  mounted() {
    loadScriptOnce('https://cdn.jsdelivr.net/npm/hls.js@latest')
      .then(() => loadScriptOnce('https://cdn.jsdelivr.net/npm/ovenplayer/dist/ovenplayer.js'))
      .then(() => loadScriptOnce('https://cdn.socket.io/4.7.5/socket.io.min.js'))
      .then(() => {
        this.initPlayer();
      })
      .catch((err) => {
        console.error('[StreamPlayer] Laden der Player-Bibliotheken fehlgeschlagen:', err);
      });
  },
  methods: {
    initPlayer() {
(function() {
  var C = {"dashboardUrl": "https://stream2.m-eventtechnik.ch", "domain": "video2.m-eventtechnik.ch", "app": "app", "key": "Venet-Stream-s2", "webrtc": true, "hls": false, "qualities": [{"id": "original", "suffix": "_hd", "label": "Original (Beste Qualität)"}], "showAuto": false, "defaultSource": "webrtc", "webrtcPort": 3344, "llhlsPort": 8181, "streamNumber": "1000"};
  var streamNumQuery = C.streamNumber ? ('?sn=' + encodeURIComponent(C.streamNumber)) : '';
  var container = document.getElementById('lp-player');
  var videoEl = document.getElementById('lp-video');
  var player = null;
  var source = C.defaultSource;
  var quality = 'auto';
  var _userPickedQuality = false;
  var volume = 0.8;
  var muted = false;
  var hideTimer = null;
  
  // Pre-Roll Variablen
  var prerollPlayed = false;
  var prerollEl = null;
  var prerollVideo = null;
  var prerollSkipBtn = null;
  var prerollConfig = null;
  var prerollCountdown = 5;

  // Wartebildschirm Variablen
  var waitingConfig = null;
  var waitingActive = false;
  var _forcedWaitingActive = false;
  var _resumeStreamAfterForcedWaiting = false;
  var _resumePrerollAfterForcedWaiting = false;
  var _forcedWaitingPrevUserPaused = false;
  var countdownInterval = null;
  var streamCheckInterval = null;
  var _streamMonitorFallbackInterval = null;
  var _prerollIdleTimer = null;

  // === STREAM-STATUS-MONITOR (WebSocket) + SESSION TRACKING ===
  var _streamWasOnline = null;  // null = unbekannt, true/false = letzter Status
  var _embedRoutePending = true;  // true bis erste Route (Warten vs Stream) feststeht — verhindert WS-Reload-Race
  var _wsSocket = null;
  var _userPaused = false;  // true wenn Nutzer manuell Pause gedrueckt hat
  var _prerollPlaying = false;  // true waehrend Preroll-Video laeuft

  // Session-ID für Viewer-Tracking (einzigartig pro Player-Instanz)
  var _viewerSessionId = (function() {
    try { return crypto.randomUUID(); }
    catch(e) { return 'v_' + Math.random().toString(36).substr(2, 12) + '_' + Date.now(); }
  })();
  var _heartbeatInterval = null;

  function _sendViewerJoin() {
    if (_wsSocket && _wsSocket.connected) {
      _wsSocket.emit('viewer_join', { session_id: _viewerSessionId });
      console.log('[Session] Join gesendet:', _viewerSessionId);
    }
  }

  function _startHeartbeat() {
    if (_heartbeatInterval) clearInterval(_heartbeatInterval);
    _heartbeatInterval = setInterval(function() {
      if (_wsSocket && _wsSocket.connected) {
        _wsSocket.emit('viewer_heartbeat', { session_id: _viewerSessionId });
      }
    }, 12000);
  }

  function _sendViewerLeave() {
    if (_wsSocket && _wsSocket.connected) {
      _wsSocket.emit('viewer_leave', { session_id: _viewerSessionId });
    }
    if (_heartbeatInterval) { clearInterval(_heartbeatInterval); _heartbeatInterval = null; }
  }

  // beforeunload + visibilitychange: Session beenden wenn User die Seite verlaesst
  window.addEventListener('beforeunload', _sendViewerLeave);
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') {
      if (_wsSocket && _wsSocket.connected) {
        _wsSocket.emit('viewer_leave', { session_id: _viewerSessionId });
      }
    } else if (document.visibilityState === 'visible') {
      _sendViewerJoin();
    }
  });

  function startStreamMonitor() {
    // WebSocket-Verbindung zum Dashboard aufbauen
    if (_wsSocket) { try { _wsSocket.disconnect(); } catch(e) {} }
    if (_streamMonitorFallbackInterval) {
      clearInterval(_streamMonitorFallbackInterval);
      _streamMonitorFallbackInterval = null;
    }
    
    try {
      _wsSocket = io(C.dashboardUrl, {
        transports: ['websocket'],
        reconnection: true,
        reconnectionDelay: 2000,
        reconnectionAttempts: Infinity
      });

      _wsSocket.on('connect', function() {
        console.log('[WS] Verbunden mit Dashboard');
        _sendViewerJoin();
        _startHeartbeat();
        // Nach Reconnect serverseitigen Priority-Lock synchronisieren.
        try {
          if (typeof loadForcedWaitingStatus === 'function') loadForcedWaitingStatus();
        } catch(e) {}
      });

      _wsSocket.on('stream_status', function(data) {
        var online = data.online === true;
        console.log('[WS] stream_status:', online, data.protocol || '', data.source || '');
        
        // Wechsel von Offline → Online erkannt?
        if (_streamWasOnline === false && online === true) {
          if (_embedRoutePending) {
            console.log('[WS] Offline→Online waehrend Initial-Route — ignoriert (kein Reload)');
          } else if (_userPaused) {
            console.log('[WS] Offline→Online, aber Nutzer hat pausiert — KEIN Auto-Reload');
          } else if (waitingActive || _forcedWaitingActive) {
            console.log('[WS] Offline→Online, aber Wartebildschirm aktiv — Wartebild-Flow uebernimmt');
            // Nicht eingreifen! startStreamPolling() erkennt online und
            // ruft hideWaitingScreen → loadPrerollConfig → startPreroll auf
          } else if (_prerollPlaying) {
            console.log('[WS] Offline→Online, aber Preroll laeuft — KEIN Auto-Reload');
          } else {
            console.log('[WS] Offline→Online! Player wird in 1s komplett neu geladen...');
            setTimeout(function() { fullPlayerReload(); }, 1000);
          }
        }
        _streamWasOnline = online;
      });

      // Standbild sofort ein-/ausblenden (vom Dashboard gesteuert)
      _wsSocket.on('waiting_force', function(data) {
        console.log('[WS] waiting_force:', data.action);
        if (data.action === 'show') {
          _forcedWaitingActive = (data.hard_lock !== false);
          _resumeStreamAfterForcedWaiting = false;
          _resumePrerollAfterForcedWaiting = false;
          _forcedWaitingPrevUserPaused = _userPaused;

          // Aktiven Inhalt pausieren, damit er spaeter fortgesetzt werden kann.
          if (_prerollPlaying && prerollVideo && !prerollVideo.paused) {
            try { prerollVideo.pause(); } catch(e) {}
            _resumePrerollAfterForcedWaiting = true;
          } else if (player && typeof player.getState === 'function') {
            try {
              if (player.getState() === 'playing') {
                player.pause();
                // Verhalten wie manuelle Pause erzwingen.
                _userPaused = true;
                _resumeStreamAfterForcedWaiting = true;
              }
            } catch(e) {}
          }

          // Wartebildschirm-Config neu laden und dann anzeigen
          loadWaitingConfig(function() {
            // Immer explizit anzeigen (auch wenn waitingActive intern stale ist)
            showWaitingScreen(true);
          });
        } else if (data.action === 'hide') {
          if (waitingActive) {
            hideWaitingScreen(true);
          }
          _forcedWaitingActive = false;
        }
      });

      _wsSocket.on('disconnect', function() {
        console.log('[WS] Verbindung getrennt, reconnect...');
      });

      _wsSocket.on('connect_error', function(err) {
        console.warn('[WS] Verbindungsfehler:', err.message || err);
      });
    } catch(e) {
      console.warn('[WS] Socket.IO nicht verfuegbar, Fallback auf Polling');
      startStreamMonitorFallback();
    }
  }

  // Fallback: Polling falls WebSocket nicht funktioniert
  function startStreamMonitorFallback() {
    var _lastPollOnline = false;
    if (_streamMonitorFallbackInterval) {
      clearInterval(_streamMonitorFallbackInterval);
    }
    _streamMonitorFallbackInterval = setInterval(function() {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', C.dashboardUrl + '/api/stream/status', true);
      xhr.timeout = 5000;
      xhr.onload = function() {
        var online = false;
        if (xhr.status === 200) {
          try { online = JSON.parse(xhr.responseText).online === true; } catch(e) {}
        }
        // Im Polling-Fallback: nur bei Stream-Wiederherstellung reloaden
        if (_lastPollOnline === false && online === true) {
          if (_embedRoutePending) {
            console.log('[POLL] Offline→Online waehrend Initial-Route — ignoriert');
          } else if (_userPaused) {
            console.log('[POLL] Offline→Online, aber Nutzer hat pausiert — KEIN Auto-Reload');
          } else if (waitingActive || _forcedWaitingActive || _prerollPlaying) {
            console.log('[POLL] Offline→Online, aber Wartebildschirm/Preroll aktiv — KEIN Auto-Reload');
          } else {
            setTimeout(function() { fullPlayerReload(); }, 3000);
          }
        }
        _lastPollOnline = online;
        _streamWasOnline = online;
      };
      xhr.onerror = function() { _streamWasOnline = false; _lastPollOnline = false; };
      xhr.send();
    }, 5000);
  }

  function fullPlayerReload() {
    // Nicht eingreifen wenn Wartebildschirm aktiv oder Preroll laeuft
    if (waitingActive) {
      console.log('[WS] fullPlayerReload uebersprungen — Wartebildschirm aktiv');
      return;
    }
    if (_prerollPlaying) {
      console.log('[WS] fullPlayerReload uebersprungen — Preroll laeuft');
      return;
    }
    _embedRoutePending = true;
    console.log('[WS] === FULL PLAYER RELOAD ===');

    // 1. Alle laufenden Intervalle/Timer stoppen
    if (streamCheckInterval) { clearInterval(streamCheckInterval); streamCheckInterval = null; }
    if (countdownInterval) { clearInterval(countdownInterval); countdownInterval = null; }
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    if (_streamMonitorFallbackInterval) { clearInterval(_streamMonitorFallbackInterval); _streamMonitorFallbackInterval = null; }
    if (_prerollIdleTimer) { clearTimeout(_prerollIdleTimer); _prerollIdleTimer = null; }
    // WebSocket bleibt verbunden! Nicht disconnecten.

    // 2. Bestehenden OvenPlayer komplett zerstoeren
    if (player) {
      try { player.remove(); } catch(e) {}
      player = null;
    }

    // 3. Zustand zurücksetzen
    // WICHTIG: prerollPlayed wird NICHT zurückgesetzt!
    // → PreRoll wird nur 1x pro Seiten-Session gezeigt
    // → Bei vollem Browser-Reload (F5) startet prerollPlayed als false → PreRoll wird erneut gezeigt
    prerollConfig = null;
    waitingActive = false;
    waitingConfig = null;

    // 4. PreRoll ausblenden falls es noch sichtbar ist
    var prEl = document.getElementById('lp-preroll');
    if (prEl) prEl.style.display = 'none';

    // 5. Wartebildschirm ausblenden falls sichtbar
    var waitEl = document.getElementById('lp-waiting');
    if (waitEl) { waitEl.style.display = 'none'; waitEl.style.opacity = '1'; }

    // 6. Black-Hold aktiv lassen bis die Zielansicht entschieden ist
    videoEl.style.display = 'none';
    videoEl.style.visibility = 'hidden';
    videoEl.innerHTML = '<div id="lp-oven"></div>';
    var bar = document.querySelector('.lp-bar');
    if (bar) bar.style.display = 'none';

    // 7. Gesamten Init-Flow von vorne starten
    loadPlayerConfig(function() {
      loadWaitingConfig(function() {
        var hasCountdown = waitingConfig && waitingConfig.countdown
          && waitingConfig.countdown.enabled && waitingConfig.countdown.datetime;
        var countdownInFuture = hasCountdown
          && new Date(waitingConfig.countdown.datetime).getTime() > Date.now();

        var waitingEnabled = waitingConfig && waitingConfig.enabled;
        checkStreamOnline(function(online) {
          _streamWasOnline = online;
          if (waitingEnabled && countdownInFuture) {
            showWaitingScreen();
          } else if (online) {
            loadPrerollConfig();
          } else if (waitingEnabled) {
            showWaitingScreen();
          } else {
            loadPrerollConfig();
          }
          _embedRoutePending = false;
        });
      });
    });
  }

  // === PRE-ROLL TRACKING ===
  function trackPreroll(videoUrl, action) {
    try {
      var tXhr = new XMLHttpRequest();
      tXhr.open('POST', C.dashboardUrl + '/api/preroll/track', true);
      tXhr.setRequestHeader('Content-Type', 'application/json');
      tXhr.send(JSON.stringify({ video: videoUrl, action: action }));
      console.log('[TRACKING] ' + action + ': ' + videoUrl);
    } catch(e) { console.warn('[TRACKING] Fehler:', e); }
  }

  // (Duplikat-trackPreroll entfernt - erste Definition wird verwendet)

  // === VIEWER TRACKING ===
  var _viewerSid = 'v_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
  var _viewerConnectTime = Date.now();
  var _viewerThrottle = {};

  function trackViewer(event, extra) {
    try {
      // Throttle: max 1 Event pro Typ pro 5 Sekunden
      var now = Date.now();
      if (_viewerThrottle[event] && (now - _viewerThrottle[event]) < 5000) return;
      _viewerThrottle[event] = now;
      
      var payload = { sid: _viewerSid, event: event };
      if (extra) { for (var k in extra) { if (extra.hasOwnProperty(k)) payload[k] = extra[k]; } }
      var xhr = new XMLHttpRequest();
      xhr.open('POST', C.dashboardUrl + '/api/viewer/track', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(payload));
    } catch(e) {}
  }

  // Fullscreen-Tracking
  document.addEventListener('fullscreenchange', function() {
    trackViewer('fullscreen');
  });

  // Tab-Sichtbarkeit
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      trackViewer('visibility_hidden');
    } else {
      trackViewer('visibility_visible');
    }
  });

  // Disconnect bei Seitenabbruch
  window.addEventListener('beforeunload', function() {
    var dur = (Date.now() - _viewerConnectTime) / 1000;
    try {
      var payload = JSON.stringify({ sid: _viewerSid, event: 'disconnect', duration: Math.round(dur) });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(C.dashboardUrl + '/api/viewer/track', new Blob([payload], {type: 'application/json'}));
      } else {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', C.dashboardUrl + '/api/viewer/track', false);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(payload);
      }
    } catch(e) {}
  });

  // === DYNAMISCHE CONFIG: Lädt Protokoll- & Qualitätseinstellungen vom Dashboard ===
  function loadPlayerConfig(callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', C.dashboardUrl + '/api/player/config' + streamNumQuery, true);
    xhr.timeout = 5000;
    xhr.onload = function() {
      if (xhr.status === 200) {
        try {
          var nc = JSON.parse(xhr.responseText);
          if (nc && !nc.error) {
            var dbUrl = C.dashboardUrl;
            C.domain = nc.domain || C.domain;
            C.app = nc.app || C.app;
            C.key = nc.key || C.key;
            C.webrtc = nc.webrtc !== undefined ? nc.webrtc : C.webrtc;
            C.hls = nc.hls !== undefined ? nc.hls : C.hls;
            C.qualities = nc.qualities || C.qualities;
            C.defaultSource = nc.defaultSource || C.defaultSource;
            C.webrtcPort = nc.webrtcPort || C.webrtcPort || 3334;
            C.llhlsPort = nc.llhlsPort || C.llhlsPort || 8081;
            C.dashboardUrl = dbUrl;
          }
        } catch(e) {}
      }
      applyConfig();
      if (callback) callback();
    };
    xhr.onerror = function() { applyConfig(); if (callback) callback(); };
    xhr.ontimeout = function() { applyConfig(); if (callback) callback(); };
    xhr.send();
  }

  function _hasQualityId(list, qid) {
    if (!list || !qid) return false;
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === qid) return true;
    }
    return false;
  }

  function _pickDefaultStartupQualityId(list) {
    if (!list || list.length === 0) return 'auto';
    if (_hasQualityId(list, 'hd')) return 'hd';
    var below = ['480p', 'sd'];
    for (var b = 0; b < below.length; b++) {
      if (_hasQualityId(list, below[b])) return below[b];
    }
    return list[list.length - 1].id;
  }

  function _qualityStillValid(q, list) {
    if (q === 'auto') return true;
    return _hasQualityId(list, q);
  }

  function applyConfig() {
    // Quelle setzen
    if (!C.webrtc && C.hls) source = 'hls';
    else if (C.webrtc && !C.hls) source = 'webrtc';
    else source = C.defaultSource || 'webrtc';

    // Source-Buttons: nur wenn beide Protokolle aktiv
    var srcDiv = document.getElementById('lp-sources');
    if (srcDiv) srcDiv.style.display = (C.webrtc && C.hls) ? 'flex' : 'none';

    // Qualitäts-Dropdown dynamisch aufbauen
    var qualSel = document.getElementById('lp-quality');
    if (qualSel && C.qualities) {
      qualSel.innerHTML = '';
      if (C.qualities.length >= 1) {
        if (C.showAuto !== false) {
          var opt = document.createElement('option');
          opt.value = 'auto'; opt.textContent = 'Automatisch';
          qualSel.appendChild(opt);
        }
        for (var i = 0; i < C.qualities.length; i++) {
          var o = document.createElement('option');
          o.value = C.qualities[i].id; o.textContent = C.qualities[i].label;
          qualSel.appendChild(o);
        }
        var pick;
        if (_userPickedQuality && _qualityStillValid(quality, C.qualities)) {
          pick = quality;
        } else {
          pick = _pickDefaultStartupQualityId(C.qualities);
          if (_userPickedQuality && !_qualityStillValid(quality, C.qualities)) {
            _userPickedQuality = false;
          }
        }
        quality = pick;
        for (var si = 0; si < qualSel.options.length; si++) {
          qualSel.options[si].selected = qualSel.options[si].value === pick;
        }
        qualSel.style.display = 'block';
      } else {
        qualSel.style.display = 'none';
        quality = 'auto';
      }
    }

    // Source-Buttons aktiven Zustand updaten
    var btnW = document.getElementById('lp-src-webrtc');
    var btnH = document.getElementById('lp-src-hls');
    if (btnW) btnW.className = source === 'webrtc' ? 'on' : '';
    if (btnH) btnH.className = source === 'hls' ? 'on' : '';
  }

  function getUrl(q) {
    var qObj = q === 'auto' ? C.qualities[0] : C.qualities.find(function(x) { return x.id === q; });
    var suffix = qObj ? qObj.suffix : C.qualities[0].suffix;
    var webrtcPort = C.webrtcPort || 3334;
    var llhlsPort = C.llhlsPort || 8081;
    return source === 'webrtc'
      ? 'wss://' + C.domain + ':' + webrtcPort + '/' + C.app + '/' + C.key + suffix
      : 'https://' + C.domain + ':' + llhlsPort + '/' + C.app + '/' + C.key + suffix + '/llhls.m3u8';
  }

  function getSources() {
    if (quality === 'auto') {
      return C.qualities.map(function(q) {
        return { type: source === 'webrtc' ? 'webrtc' : 'hls', file: getUrl(q.id), label: q.label };
      });
    }
    return [{ type: source === 'webrtc' ? 'webrtc' : 'hls', file: getUrl(quality) }];
  }

  var _embedReconnectTimer = null;
  var _embedReconnectAttempts = 0;
  var _embedMaxReconnects = 120;

  function initPlayer() {
    if (player) { try { player.remove(); } catch(e) {} }
    videoEl.innerHTML = '<div id="lp-oven"></div>';
    var shouldAutoStart = !_userPaused;
    player = OvenPlayer.create('lp-oven', {
      autoStart: shouldAutoStart,
      mute: muted,
      volume: volume * 100,
      controls: false,
      playsinline: true,
      sources: getSources(),
      webrtcConfig: {
        timeoutMaxRetry: 30,
        connectionTimeout: 10000
      },
      hlsConfig: {
        enableWorker: true,
        lowLatencyMode: true
      }
    });
    // iOS/Safari: playsinline Attribut auf das erstellte Video-Element setzen
    try {
      var vid = document.querySelector('#lp-oven video');
      if (vid) {
        vid.setAttribute('playsinline', '');
        vid.setAttribute('webkit-playsinline', '');
      }
    } catch(e) {}
    player.on('stateChanged', function(s) {
      var icon = s.newstate === 'playing' 
        ? '<path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>' 
        : '<path d="M8 5v14l11-7z"/>';
      document.getElementById('lp-play').innerHTML = '<svg viewBox="0 0 24 24">' + icon + '</svg>';
      var liveEl = document.getElementById('lp-live');
      if (s.newstate === 'playing') {
        liveEl.classList.add('lp-playing');
        _embedReconnectAttempts = 0;
        clearTimeout(_embedReconnectTimer);
        trackViewer('play');
      } else {
        liveEl.classList.remove('lp-playing');
      }
      if (s.newstate === 'paused') trackViewer('pause');
      if (s.newstate === 'loading') trackViewer('buffer');
    });
    player.on('error', function(err) {
      console.error('[PLAYER] Error:', err);
      if (_userPaused || _prerollPlaying || waitingActive) return;
      if (_embedReconnectAttempts < _embedMaxReconnects) {
        _embedReconnectAttempts++;
        var delay = Math.min(1500 + (_embedReconnectAttempts * 300), 4000);
        console.log('[PLAYER] Auto-Reconnect ' + _embedReconnectAttempts + '/' + _embedMaxReconnects + ' in ' + delay + 'ms');
        clearTimeout(_embedReconnectTimer);
        _embedReconnectTimer = setTimeout(function() {
          if (player) { try { player.remove(); } catch(e) {} player = null; }
          videoEl.innerHTML = '<div id="lp-oven"></div>';
          initPlayer();
        }, delay);
      }
    });
  }

  function updateUI() {
    var btnW = document.getElementById('lp-src-webrtc');
    var btnH = document.getElementById('lp-src-hls');
    if (btnW) btnW.className = source === 'webrtc' ? 'on' : '';
    if (btnH) btnH.className = source === 'hls' ? 'on' : '';
    
    var volIcon = document.getElementById('lp-vol-icon');
    if (muted || volume === 0) {
      volIcon.innerHTML = '<path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>';
    } else {
      volIcon.innerHTML = '<path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>';
    }
  }

  // Auto-Hide Logik mit lp-idle Klasse
  function resetIdleTimer() {
    container.classList.remove('lp-idle');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function() {
      container.classList.add('lp-idle');
    }, 3000);
  }

  function toggleFullscreen() {
    if (document.fullscreenElement || document.webkitFullscreenElement || container.classList.contains('lp-fs')) {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      container.classList.remove('lp-fs');
    } else {
      if (container.requestFullscreen) container.requestFullscreen();
      else if (container.webkitRequestFullscreen) container.webkitRequestFullscreen();
      else {
        // iOS Safari: Video-Element direkt fullscreenen
        var vid = document.querySelector('#lp-oven video');
        if (vid && vid.webkitEnterFullscreen) vid.webkitEnterFullscreen();
      }
      container.classList.add('lp-fs');
    }
    resetIdleTimer();
  }

  // Event Listeners
  document.getElementById('lp-play').onclick = function() {
    if (player) {
      var state = player.getState();
      if (state === 'playing') {
        player.pause();
        _userPaused = true;
        console.log('[PLAYER] Manuell pausiert — kein Auto-Play/Reload');
      } else {
        player.play();
        _userPaused = false;
      }
    }
    resetIdleTimer();
  };

  document.getElementById('lp-mute').onclick = function() {
    muted = !muted;
    if (player) player.setMute(muted);
    trackViewer(muted ? 'mute' : 'unmute');
    updateUI();
    resetIdleTimer();
  };

  document.getElementById('lp-volume').oninput = function() {
    volume = this.value / 100;
    muted = volume === 0;
    if (player) {
      player.setVolume(volume * 100);
      player.setMute(muted);
    }
    updateUI();
    resetIdleTimer();
  };

  var srcWebrtc = document.getElementById('lp-src-webrtc');
  var srcHls = document.getElementById('lp-src-hls');
  if (srcWebrtc) srcWebrtc.onclick = function() {
    if (source !== 'webrtc') { source = 'webrtc'; initPlayer(); updateUI(); }
    resetIdleTimer();
  };
  if (srcHls) srcHls.onclick = function() {
    if (source !== 'hls') {
      var msg = 'Sind Sie sicher, dass Sie von WebRTC auf LL-HLS umschalten möchten?\n\n' +
                'Die Bildqualität ist auf LL-HLS besser, jedoch wird der Stream ca. 3-10 Sekunden verzögert!\n\n' +
                'Für Versteigerungen nicht geeignet!';
      if (confirm(msg)) {
        source = 'hls';
        initPlayer();
        updateUI();
      }
    }
    resetIdleTimer();
  };

  document.getElementById('lp-quality').onchange = function() {
    if (quality !== this.value) {
      _userPickedQuality = true;
      quality = this.value;
      initPlayer();
    }
    resetIdleTimer();
  };

  document.getElementById('lp-fs').onclick = function() {
    toggleFullscreen();
  };

  // Tastatur: Leertaste nur wenn Fokus nicht auf Slider/Buttons (iframe braucht Fokus im Dokument)
  function _lpIsSpaceHandledByControl(target) {
    if (!target) return false;
    var el = target;
    try {
      if (el.shadowRoot && el.shadowRoot.activeElement) el = el.shadowRoot.activeElement;
    } catch (err) {}
    var tag = (el.tagName || '').toUpperCase();
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || tag === 'BUTTON') return true;
    if (el.isContentEditable) return true;
    try {
      if (el.closest && (el.closest('button') || el.closest('input') || el.closest('select') || el.closest('textarea'))) return true;
    } catch (e2) {}
    return false;
  }

  container.addEventListener('pointerdown', function(e) {
    if (_lpIsSpaceHandledByControl(e.target)) return;
    try { container.focus({ preventScroll: true }); } catch (err) { try { container.focus(); } catch (e2) {} }
  }, true);

  // Mouse/Touch Events für Auto-Hide Reset
  container.onmousemove = resetIdleTimer;
  container.onmouseenter = resetIdleTimer;
  container.onclick = resetIdleTimer;

  container.ontouchstart = function(e) {
    resetIdleTimer();
  };

  // Video-Bereich Klick: Play/Pause
  videoEl.onclick = function(e) {
    e.stopPropagation();
    if (player) {
      var state = player.getState();
      if (state === 'playing') {
        player.pause();
        _userPaused = true;
        console.log('[PLAYER] Manuell pausiert — kein Auto-Play/Reload');
      } else {
        player.play();
        _userPaused = false;
      }
    }
    resetIdleTimer();
  };

  // Doppelklick: Vollbild
  videoEl.ondblclick = function() {
    toggleFullscreen();
  };

  // Fullscreen Change Event
  document.addEventListener('fullscreenchange', function() {
    if (!document.fullscreenElement) {
      container.classList.remove('lp-fs');
    }
    resetIdleTimer();
  });

  // Leertaste für Play/Pause (Pre-Roll: HTML5-Video; sonst OvenPlayer)
  document.addEventListener('keydown', function(e) {
    if (e.code !== 'Space' && e.key !== ' ') return;
    if (_lpIsSpaceHandledByControl(e.target)) return;
    e.preventDefault();
    if (_prerollPlaying && prerollVideo) {
      if (prerollVideo.paused) {
        prerollVideo.play().catch(function() {});
      } else {
        prerollVideo.pause();
      }
      resetIdleTimer();
      return;
    }
    if (player) {
      var state = player.getState();
      if (state === 'playing') {
        player.pause();
        _userPaused = true;
        console.log('[PLAYER] Manuell pausiert — kein Auto-Play/Reload');
      } else {
        player.play();
        _userPaused = false;
      }
    }
    resetIdleTimer();
  });

  // Pre-Roll Funktionen
  function startPreroll() {
    // Prüfe ob Pre-Roll aktiviert und konfiguriert ist
    if (!prerollConfig || !prerollConfig.enabled || !prerollConfig.url || prerollPlayed) {
      startStream();
      return;
    }
    
    // WICHTIG: Flags sofort setzen um Loops zu verhindern
    prerollPlayed = true;
    _prerollPlaying = true;
    
    // Hole Pre-Roll Elemente
    prerollEl = document.getElementById('lp-preroll');
    prerollVideo = document.getElementById('lp-preroll-video');
    prerollSkipBtn = document.getElementById('lp-preroll-skip');
    
    // Sicherheitscheck
    if (!prerollEl || !prerollVideo) {
      console.error('Pre-Roll Elemente nicht gefunden');
      _prerollPlaying = false;
      startStream();
      return;
    }
    
    // Zeige Pre-Roll, verstecke Stream-Player
    prerollEl.style.display = 'flex';
    videoEl.style.visibility = 'hidden';
    document.querySelector('.lp-bar').style.display = 'none';
    
    // Video Setup - NICHT automatisch starten, Click-to-Play mit Ton
    prerollVideo.src = prerollConfig.url;
    prerollVideo.muted = false;  // MIT Ton starten nach User-Klick
    prerollVideo.volume = volume;
    prerollVideo.controls = false;
    
    // UI Elemente
    var playOverlay = document.getElementById('lp-preroll-play-overlay');
    var prerollBar = document.getElementById('lp-preroll-bar');
    var skipWrap = document.getElementById('lp-preroll-skip-wrap');
    var prerollVolumeSlider = document.getElementById('lp-preroll-volume');
    // Auto-Hide Timer für Control-Bar (NUR wenn Video spielt)
    function resetPrerollIdleTimer() {
      prerollEl.classList.remove('lp-idle');
      clearTimeout(_prerollIdleTimer);
      _prerollIdleTimer = setTimeout(function() {
        // Nur ausblenden wenn Video SPIELT (nicht pausiert)
        if (!prerollVideo.paused) {
          prerollEl.classList.add('lp-idle');
        }
      }, 3000);
    }
    
    // Zeige Play-Overlay sofort wenn Metadaten geladen
    prerollVideo.onloadedmetadata = function() {
      if (playOverlay) playOverlay.style.display = 'flex';
    };
    
    // Fallback: Falls Metadaten schon geladen sind
    if (prerollVideo.readyState >= 1 && playOverlay) {
      playOverlay.style.display = 'flex';
    }
    
    // Klick auf Overlay startet Video mit Ton
    if (playOverlay) {
      playOverlay.onclick = function() {
        playOverlay.style.display = 'none';
        if (prerollBar) prerollBar.style.display = 'flex';
        // Skip-Button nur anzeigen wenn NICHT "Nie" (< 61)
        var skipSetting = prerollConfig.skipAfter || 5;
        if (skipWrap && skipSetting < 61) {
          skipWrap.style.display = 'block';
        }
        resetPrerollIdleTimer();
        // Tracking: View registrieren
        if (prerollVideo && prerollVideo.src) {
          trackPreroll(prerollVideo.src, 'view');
        }
        prerollVideo.play().catch(function(e) {
          console.warn('Play fehlgeschlagen:', e);
          prerollVideo.muted = true;
          prerollVideo.play();
        });
      };
    }
    
    // Mouse/Touch Events für Auto-Hide Reset
    prerollEl.onmousemove = resetPrerollIdleTimer;
    prerollEl.onclick = resetPrerollIdleTimer;
    prerollEl.ontouchstart = resetPrerollIdleTimer;
    
    // Skip-Button Initial-Setup
    var skipAfter = prerollConfig.skipAfter || 5;
    var skipTextEl = document.getElementById('lp-skip-text');
    var lastSkipRemaining = -1;
    
    if (prerollSkipBtn) {
      if (skipAfter === 0) {
        // Sofort überspringbar
        prerollSkipBtn.disabled = false;
        if (skipTextEl) skipTextEl.textContent = 'Überspringen';
      } else if (skipAfter >= 61) {
        // Nie überspringbar - Wrapper verstecken
        if (skipWrap) skipWrap.style.display = 'none';
      } else {
        // Warte-Modus - Zeige Countdown
        prerollSkipBtn.disabled = true;
        if (skipTextEl) skipTextEl.textContent = skipAfter + 's';
      }
    }
    
    // EVENT: Countdown im Skip-Button aktualisieren
    prerollVideo.ontimeupdate = function() {
      if (!prerollSkipBtn || !skipTextEl || skipAfter >= 61 || skipAfter === 0) return;
      
      var currentTime = prerollVideo.currentTime;
      var remaining = Math.ceil(skipAfter - currentTime);
      
      // Nur updaten wenn sich die Zahl ändert (Performance)
      if (remaining !== lastSkipRemaining) {
        lastSkipRemaining = remaining;
        
        if (remaining > 0) {
          skipTextEl.textContent = remaining + 's';
        } else if (prerollSkipBtn.disabled) {
          // Countdown fertig - Button aktivieren
          prerollSkipBtn.disabled = false;
          skipTextEl.textContent = 'Überspringen';
        }
      }
    };
    
    // EVENT: Video zu Ende - automatisch zum Stream
    prerollVideo.onended = function() {
      // Nur wenn Video wirklich abgespielt wurde (nicht bei sofortigem Ende)
      if (prerollVideo.currentTime > 0.5) {
        console.log('Pre-Roll beendet (Zeit: ' + prerollVideo.currentTime + 's), starte Stream');
        // Tracking: Vollständig angesehen
        if (prerollVideo.src) {
          trackPreroll(prerollVideo.src, 'complete');
        }
        endPreroll();
      }
    };
    
    // EVENT: Fehler beim Laden - direkt zum Stream (nur bei echten Fehlern)
    prerollVideo.onerror = function(e) {
      // Nur bei echten Netzwerk/Decode-Fehlern reagieren
      if (prerollVideo.error && prerollVideo.error.code) {
        console.warn('Pre-Roll Video Fehler (Code ' + prerollVideo.error.code + '), starte Stream direkt');
        endPreroll();
      }
    };
    
    // EVENT: Skip-Button Klick
    if (prerollSkipBtn) {
      prerollSkipBtn.onclick = function() {
        if (!prerollSkipBtn.disabled) {
          console.log('Skip geklickt');
          // Tracking: Skip registrieren
          if (prerollVideo && prerollVideo.src) {
            trackPreroll(prerollVideo.src, 'skip');
          }
          endPreroll();
        }
      };
    }
    
    // Pre-Roll Control Elements
    var prerollPlayBtn = document.getElementById('lp-preroll-play');
    var prerollMuteBtn = document.getElementById('lp-preroll-mute');
    var prerollFsBtn = document.getElementById('lp-preroll-fs');
    var prerollVolIcon = document.getElementById('lp-preroll-vol-icon');
    
    // Play/Pause Button
    if (prerollPlayBtn) {
      prerollPlayBtn.onclick = function() {
        if (prerollVideo.paused) {
          prerollVideo.play();
        } else {
          prerollVideo.pause();
        }
      };
    }
    
    // Update Play/Pause Icon
    prerollVideo.onplay = function() {
      if (prerollPlayBtn) prerollPlayBtn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>';
    };
    prerollVideo.onpause = function() {
      if (prerollPlayBtn) prerollPlayBtn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
    };
    
    // Klick auf Video für Play/Pause (nur wenn Video bereits läuft)
    prerollVideo.onclick = function(e) {
      // Ignoriere Klicks wenn Overlay noch sichtbar ist
      if (playOverlay && playOverlay.style.display !== 'none') return;
      
      if (prerollVideo.paused) {
        prerollVideo.play();
      } else {
        prerollVideo.pause();
      }
    };
    
    // Mute Button
    if (prerollMuteBtn) {
      prerollMuteBtn.onclick = function() {
        prerollVideo.muted = !prerollVideo.muted;
        updatePrerollVolIcon();
        // Sync Slider
        if (prerollVolumeSlider) {
          prerollVolumeSlider.value = prerollVideo.muted ? 0 : prerollVideo.volume * 100;
        }
      };
    }
    
    // Volume Slider
    if (prerollVolumeSlider) {
      // Initialer Wert
      prerollVolumeSlider.value = volume * 100;
      
      prerollVolumeSlider.oninput = function() {
        var val = this.value / 100;
        prerollVideo.volume = val;
        prerollVideo.muted = val === 0;
        updatePrerollVolIcon();
        resetPrerollIdleTimer();
      };
    }
    
    function updatePrerollVolIcon() {
      if (!prerollVolIcon) return;
      if (prerollVideo.muted || prerollVideo.volume === 0) {
        prerollVolIcon.innerHTML = '<path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>';
      } else {
        prerollVolIcon.innerHTML = '<path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>';
      }
    }
    
    // Fullscreen Button
    if (prerollFsBtn) {
      prerollFsBtn.onclick = function() {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else {
          container.requestFullscreen().catch(function() {
            // Fallback
            prerollEl.requestFullscreen && prerollEl.requestFullscreen();
          });
        }
      };
    }
    
    
    // Stalled-Event: Video neu starten wenn es hängt
    prerollVideo.onstalled = function() {
      console.log('Video stalled, versuche Neustart...');
      var currentTime = prerollVideo.currentTime;
      prerollVideo.load();
      prerollVideo.currentTime = currentTime;
      prerollVideo.play().catch(function() {});
    };
    
    // Video wird NICHT automatisch gestartet - wartet auf User-Klick
    console.log('Pre-Roll bereit, warte auf User-Klick');
  }
  
  function endPreroll() {
    console.log('endPreroll aufgerufen');
    _prerollPlaying = false;
    if (_prerollIdleTimer) {
      clearTimeout(_prerollIdleTimer);
      _prerollIdleTimer = null;
    }
    // UI aufräumen
    if (prerollEl) prerollEl.style.display = 'none';
    var skipW = document.getElementById('lp-preroll-skip-wrap');
    if (skipW) skipW.style.display = 'none';
    if (prerollVideo) {
      prerollVideo.pause();
      prerollVideo.onended = null;
      prerollVideo.ontimeupdate = null;
      prerollVideo.onerror = null;
      prerollVideo.onloadedmetadata = null;
      prerollVideo.src = '';
    }
    
    // Fullscreen-Status synchronisieren (Preroll-Button setzt lp-fs nicht)
    if (document.fullscreenElement) {
      container.classList.add('lp-fs');
    }
    
    // Stream-UI wieder anzeigen
    videoEl.style.display = 'block';
    videoEl.style.visibility = 'visible';
    document.querySelector('.lp-bar').style.display = 'flex';
    
    // Haupt-Stream starten
    startStream();
    // Mehrfache Layout-Neuberechnung für iframe-Kompatibilitaet
    [100, 300, 600].forEach(function(d) {
      setTimeout(function() { window.dispatchEvent(new Event('resize')); }, d);
    });
  }
  
  function startStream() {
    console.log('startStream aufgerufen');
    videoEl.style.display = 'block';
    videoEl.style.visibility = 'visible';
    var bar = document.querySelector('.lp-bar');
    if (bar) bar.style.display = 'flex';
    initPlayer();
    updateUI();
    resetIdleTimer();
  }
  
  // === WARTEBILDSCHIRM FUNKTIONEN ===
  
  // Wartebildschirm Config vom Dashboard laden
  function loadWaitingConfig(callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', C.dashboardUrl + '/api/waiting/config', true);
    xhr.timeout = 5000;
    xhr.onload = function() {
      if (xhr.status === 200) {
        try {
          waitingConfig = JSON.parse(xhr.responseText);
        } catch(e) {
          waitingConfig = null;
        }
      }
      if (callback) callback();
    };
    xhr.onerror = function() { waitingConfig = null; if (callback) callback(); };
    xhr.ontimeout = function() { waitingConfig = null; if (callback) callback(); };
    xhr.send();
  }

  // Priority-Standbild-Lock vom Dashboard holen (serverseitige Quelle der Wahrheit)
  function loadForcedWaitingStatus(callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', C.dashboardUrl + '/api/waiting/force/status', true);
    xhr.timeout = 5000;
    xhr.onload = function() {
      var active = false;
      if (xhr.status === 200) {
        try {
          var payload = JSON.parse(xhr.responseText || '{}');
          active = !!(payload && payload.success && payload.active);
        } catch(e) {}
      }
      _forcedWaitingActive = active;
      if (active) {
        _resumeStreamAfterForcedWaiting = false;
        _resumePrerollAfterForcedWaiting = false;
        loadWaitingConfig(function() {
          showWaitingScreen(true);
          if (callback) callback(true);
        });
        return;
      }
      if (callback) callback(false);
    };
    xhr.onerror = function() { if (callback) callback(false); };
    xhr.ontimeout = function() { if (callback) callback(false); };
    xhr.send();
  }

  // Stream-Online-Status prüfen (pollt /api/stream/status)
  function checkStreamOnline(callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', C.dashboardUrl + '/api/stream/status', true);
    xhr.timeout = 5000;
    xhr.onload = function() {
      var online = false;
      if (xhr.status === 200) {
        try {
          var data = JSON.parse(xhr.responseText);
          online = data.online === true;
        } catch(e) {}
      }
      if (callback) callback(online);
    };
    xhr.onerror = function() { if (callback) callback(false); };
    xhr.ontimeout = function() { if (callback) callback(false); };
    xhr.send();
  }

  // Countdown-Timer starten
  function startCountdown(targetDatetime, timerEl) {
    function updateCountdown() {
      var now = new Date().getTime();
      var target = new Date(targetDatetime).getTime();
      var diff = target - now;

      if (diff <= 0) {
        timerEl.innerHTML = '<span class="lp-cd-block"><span class="lp-cd-num">00</span><span class="lp-cd-lbl">Std</span></span>' +
          '<span class="lp-cd-sep">:</span>' +
          '<span class="lp-cd-block"><span class="lp-cd-num">00</span><span class="lp-cd-lbl">Min</span></span>' +
          '<span class="lp-cd-sep">:</span>' +
          '<span class="lp-cd-block"><span class="lp-cd-num">00</span><span class="lp-cd-lbl">Sek</span></span>';
        clearInterval(countdownInterval);
        countdownInterval = null;
        // Countdown abgelaufen → jetzt Stream-Polling starten
        onCountdownFinished();
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      var html = '';
      if (days > 0) {
        html += '<span class="lp-cd-block"><span class="lp-cd-num">' + days + '</span><span class="lp-cd-lbl">Tage</span></span><span class="lp-cd-sep">:</span>';
      }
      html += '<span class="lp-cd-block"><span class="lp-cd-num">' + String(hours).padStart(2, '0') + '</span><span class="lp-cd-lbl">Std</span></span>';
      html += '<span class="lp-cd-sep">:</span>';
      html += '<span class="lp-cd-block"><span class="lp-cd-num">' + String(minutes).padStart(2, '0') + '</span><span class="lp-cd-lbl">Min</span></span>';
      html += '<span class="lp-cd-sep">:</span>';
      html += '<span class="lp-cd-block"><span class="lp-cd-num">' + String(seconds).padStart(2, '0') + '</span><span class="lp-cd-lbl">Sek</span></span>';

      timerEl.innerHTML = html;
    }

    updateCountdown();
    countdownInterval = setInterval(updateCountdown, 1000);
  }

  // Wird aufgerufen wenn Countdown bei 0 angekommen ist
  function onCountdownFinished() {
    console.log('Countdown abgelaufen - prüfe Stream-Status');

    // Countdown mit Fade-Out ausblenden (Bild + Wartebildschirm bleiben!)
    var cdEl = document.getElementById('lp-waiting-cd');
    if (cdEl) {
      cdEl.style.transition = 'opacity 0.8s ease';
      cdEl.style.opacity = '0';
      setTimeout(function() { cdEl.style.display = 'none'; }, 800);
    }

    // Haupttext nach Countdown (leer = Zeile ausblenden)
    var textElCd = document.getElementById('lp-waiting-text');
    if (textElCd) {
      textElCd.style.transition = 'opacity 0.4s ease';
      textElCd.style.opacity = '0';
      setTimeout(function() {
        var cfg = waitingConfig || {};
        var after = (cfg.countdown && cfg.countdown.afterText) ? String(cfg.countdown.afterText).trim() : '';
        if (after) {
          textElCd.textContent = after;
          textElCd.style.display = 'block';
        } else {
          textElCd.textContent = '';
          textElCd.style.display = 'none';
        }
        textElCd.style.opacity = '1';
      }, 400);
    }

    // Sofort Stream-Status prüfen
    checkStreamOnline(function(online) {
      if (online && waitingActive && !_forcedWaitingActive) {
        hideWaitingScreen();
        return;
      }
      // Stream noch nicht online → Polling starten (Bild bleibt sichtbar)
      startStreamPolling();
    });
  }

  // Stream-Status Polling starten (alle 5 Sek.)
  function startStreamPolling() {
    if (streamCheckInterval) return; // Bereits aktiv
    streamCheckInterval = setInterval(function() {
      checkStreamOnline(function(online) {
        if (online && waitingActive && !_forcedWaitingActive) {
          hideWaitingScreen();
        }
      });
    }, 5000);
  }

  // Wartebildschirm anzeigen
  function showWaitingScreen(isForcedManual) {
    waitingActive = true;
    var manualMode = isForcedManual === true;
    var cfg = waitingConfig || {};
    var waitEl = document.getElementById('lp-waiting');
    var logoEl = document.getElementById('lp-waiting-logo');
    var textEl = document.getElementById('lp-waiting-text');
    var cdEl = document.getElementById('lp-waiting-cd');
    var cdLabel = document.getElementById('lp-waiting-cd-label');
    var cdTimer = document.getElementById('lp-waiting-cd-timer');

    if (!waitEl) return;

    // Hintergrundfarbe setzen (robust mit Fallback)
    waitEl.style.backgroundColor = cfg.bgColor || '#000000';

    // Abdunkelung über dem Standbild (0-100, Lesbarkeit)
    var ovEl = document.getElementById('lp-waiting-overlay');
    if (!ovEl) ovEl = document.querySelector('.lp-waiting-overlay');
    var dimRaw = (cfg.bgDim !== undefined && cfg.bgDim !== null) ? cfg.bgDim : (cfg.bg_dim !== undefined ? cfg.bg_dim : 0);
    var dim = parseInt(dimRaw, 10);
    if (isNaN(dim)) dim = 0;
    dim = Math.max(0, Math.min(100, dim));
    var ex = (dim / 100) * 0.72;
    if (ovEl) {
      if (dim > 0) {
        ovEl.style.background = 'linear-gradient(rgba(0,0,0,' + ex + '), rgba(0,0,0,' + ex + ')), radial-gradient(ellipse at center, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.65) 100%)';
      } else {
        ovEl.style.background = '';
      }
    }

    // Logo anzeigen
    if (cfg.logoUrl) {
      logoEl.src = cfg.logoUrl;
      logoEl.style.display = 'block';
      logoEl.onerror = function() { logoEl.style.display = 'none'; };
    } else {
      logoEl.style.display = 'none';
    }

    // Text anzeigen (leer = ausblenden, kein Fallback)
    if (textEl) {
      var screenText = (cfg.text !== undefined && cfg.text !== null) ? String(cfg.text).trim() : '';
      if (screenText) {
        textEl.textContent = screenText;
        textEl.style.display = 'block';
      } else {
        textEl.textContent = '';
        textEl.style.display = 'none';
      }
    }

    // Stream-Video und Controls verstecken
    videoEl.style.display = 'none';
    videoEl.style.visibility = 'hidden';
    var bar = document.querySelector('.lp-bar');
    if (bar) bar.style.display = 'none';
    if (prerollEl && _prerollPlaying) prerollEl.style.display = 'none';

    // Wartebildschirm einblenden
    waitEl.style.position = 'absolute';
    waitEl.style.top = '0';
    waitEl.style.left = '0';
    waitEl.style.right = '0';
    waitEl.style.bottom = '0';
    waitEl.style.zIndex = '2000001';
    waitEl.style.display = 'flex';
    waitEl.style.visibility = 'visible';
    waitEl.style.opacity = '1';

    // Manueller Toggle vom Dashboard:
    // Kein Countdown/kein Polling starten, nur pausiertes Bild uebers Stream legen.
    if (manualMode) {
      cdEl.style.display = 'none';
      if (streamCheckInterval) {
        clearInterval(streamCheckInterval);
        streamCheckInterval = null;
      }
      if (countdownInterval) {
        clearInterval(countdownInterval);
        countdownInterval = null;
      }
      return;
    }

    var hasCountdown = cfg.countdown && cfg.countdown.enabled && cfg.countdown.datetime;

    if (hasCountdown) {
      var target = new Date(cfg.countdown.datetime).getTime();
      var now = new Date().getTime();
      var cdTxt = (cfg.countdown.text != null && cfg.countdown.text !== undefined)
        ? String(cfg.countdown.text).trim() : '';
      if (cdTxt) {
        cdLabel.textContent = cdTxt;
        cdLabel.style.display = 'block';
      } else {
        cdLabel.textContent = '';
        cdLabel.style.display = 'none';
      }
      cdEl.style.display = 'block';

      if (target > now) {
        // Countdown läuft noch → Warten bis er fertig ist (KEIN Stream-Polling!)
        // Stream wird erst freigegeben wenn Countdown = 0
        startCountdown(cfg.countdown.datetime, cdTimer);
      } else {
        // Countdown bereits abgelaufen → sofort Stream-Polling starten
        cdTimer.innerHTML = '<span class="lp-cd-block"><span class="lp-cd-num">00</span><span class="lp-cd-lbl">Std</span></span>' +
          '<span class="lp-cd-sep">:</span>' +
          '<span class="lp-cd-block"><span class="lp-cd-num">00</span><span class="lp-cd-lbl">Min</span></span>' +
          '<span class="lp-cd-sep">:</span>' +
          '<span class="lp-cd-block"><span class="lp-cd-num">00</span><span class="lp-cd-lbl">Sek</span></span>';
        onCountdownFinished();
      }
    } else {
      // Kein Countdown → sofort Stream-Polling starten
      cdEl.style.display = 'none';
      startStreamPolling();
    }
  }

  // Wartebildschirm ausblenden → Pre-Roll oder Stream starten
  function hideWaitingScreen(isForcedManual) {
    if (_forcedWaitingActive && isForcedManual !== true) {
      // Priority-Lock: nur explizites manuelles "hide" darf ausblenden.
      return;
    }
    waitingActive = false;
    var manualMode = isForcedManual === true || _forcedWaitingActive === true;

    // Alle Intervalle stoppen
    if (streamCheckInterval) {
      clearInterval(streamCheckInterval);
      streamCheckInterval = null;
    }
    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }

    // Wartebildschirm mit Fade-Out ausblenden
    var waitEl = document.getElementById('lp-waiting');
    if (waitEl) {
      waitEl.style.transition = 'opacity 0.6s ease';
      waitEl.style.opacity = '0';
      setTimeout(function() {
        waitEl.style.display = 'none';
        waitEl.style.opacity = '1';
        waitEl.style.transition = '';

        // Video-Element und Controls wieder anzeigen
        videoEl.style.display = 'block';
        videoEl.style.visibility = 'visible';
        var bar = document.querySelector('.lp-bar');
        if (bar) bar.style.display = 'flex';

        if (manualMode) {
          // Bei manueller Einblendung NICHT neu initialisieren,
          // sondern pausierten Zustand exakt fortsetzen.
          if (_prerollPlaying && prerollEl) {
            prerollEl.style.display = 'flex';
            videoEl.style.visibility = 'hidden';
            if (bar) bar.style.display = 'none';
            if (_resumePrerollAfterForcedWaiting && prerollVideo) {
              prerollVideo.play().catch(function() {});
            }
          } else if (_resumeStreamAfterForcedWaiting && player) {
            try {
              player.play();
              _userPaused = _forcedWaitingPrevUserPaused ? true : false;
            } catch(e) {}
          }
          if (!_resumeStreamAfterForcedWaiting) {
            _userPaused = _forcedWaitingPrevUserPaused;
          }
          _resumeStreamAfterForcedWaiting = false;
          _resumePrerollAfterForcedWaiting = false;
          _forcedWaitingPrevUserPaused = false;
          return;
        }

        // Player-Config neu laden (aktuelle Einstellungen holen) → dann Pre-Roll/Stream
        loadPlayerConfig(function() {
          loadPrerollConfig();
        });
      }, 600);
    } else {
      videoEl.style.display = 'block';
      videoEl.style.visibility = 'visible';
      var bar2 = document.querySelector('.lp-bar');
      if (bar2) bar2.style.display = 'flex';
      if (manualMode) {
        if (_prerollPlaying && prerollEl) {
          prerollEl.style.display = 'flex';
          videoEl.style.visibility = 'hidden';
          if (bar2) bar2.style.display = 'none';
          if (_resumePrerollAfterForcedWaiting && prerollVideo) {
            prerollVideo.play().catch(function() {});
          }
        } else if (_resumeStreamAfterForcedWaiting && player) {
          try {
            player.play();
            _userPaused = _forcedWaitingPrevUserPaused ? true : false;
          } catch(e) {}
        }
        if (!_resumeStreamAfterForcedWaiting) {
          _userPaused = _forcedWaitingPrevUserPaused;
        }
        _resumeStreamAfterForcedWaiting = false;
        _resumePrerollAfterForcedWaiting = false;
        _forcedWaitingPrevUserPaused = false;
      } else {
        loadPlayerConfig(function() {
          loadPrerollConfig();
        });
      }
    }
  }

  // Pre-Roll Config dynamisch laden und dann starten
  function loadPrerollConfig() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', C.dashboardUrl + '/api/preroll/config', true);
    xhr.onload = function() {
      if (xhr.status === 200) {
        try {
          prerollConfig = JSON.parse(xhr.responseText);
          prerollCountdown = prerollConfig.skipAfter || 5;
        } catch(e) {
          prerollConfig = null;
        }
      }
      startPreroll();
    };
    xhr.onerror = function() {
      prerollConfig = null;
      startPreroll();
    };
    xhr.send();
  }
  
  // Start - Player-Config laden → Priority-Lock prüfen → Countdown/Stream-Check → Preroll → Stream
  loadPlayerConfig(function() {
    loadForcedWaitingStatus(function(forceActive) {
      if (forceActive) {
        // Priority-Lock aktiv: absoluter Vorrang, hier abbrechen.
        startStreamMonitor();
        _embedRoutePending = false;
        return;
      }
      loadWaitingConfig(function() {
      var hasCountdown = waitingConfig && waitingConfig.countdown
        && waitingConfig.countdown.enabled && waitingConfig.countdown.datetime;
      var countdownInFuture = hasCountdown
        && new Date(waitingConfig.countdown.datetime).getTime() > Date.now();

      var waitingEnabled = waitingConfig && waitingConfig.enabled;
      checkStreamOnline(function(online) {
        _streamWasOnline = online;
        if (waitingEnabled && countdownInFuture) {
          showWaitingScreen();
        } else if (online) {
          loadPrerollConfig();
        } else if (waitingEnabled) {
          showWaitingScreen();
        } else {
          loadPrerollConfig();
        }
        _embedRoutePending = false;
        startStreamMonitor();
        trackViewer('connect', {
          screen: window.innerWidth + 'x' + window.innerHeight,
          referrer: document.referrer || '',
          language: navigator.language || '',
          protocol: source
        });
      });
      });
    });
  });
})();
    }
  }
}
</script>

<style>
.lp-player {
  --lp-accent: #4299e1;
  --lp-bg: rgba(0,0,0,0.9);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  position: relative;
  max-width: 1280px;
  margin: 0 auto;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  line-height: 1;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  aspect-ratio: 16/9;
}
#lp-player:focus { outline: none; }
#lp-player:focus-visible {
  outline: 2px solid var(--lp-accent);
  outline-offset: 2px;
}
.lp-player * { box-sizing: border-box; }
.lp-video {
  width: 100%;
  aspect-ratio: 16/9;
  background: #000;
}
.lp-video > div { width: 100%; height: 100%; }

/* Control Bar - schwebt über dem Video */
.lp-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, var(--lp-bg));
  padding: 50px 15px 15px 15px;
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  z-index: 10;
}

/* IDLE State - Controls und Cursor verstecken nach 3s Inaktivität */
.lp-player.lp-idle { cursor: none !important; }
.lp-player.lp-idle .lp-bar { 
  opacity: 0 !important; 
  visibility: hidden !important;
  pointer-events: none;
}

/* Fullscreen Mode */
.lp-player.lp-fs { 
  position: fixed; 
  top: 0; left: 0; right: 0; bottom: 0; 
  max-width: none; 
  border-radius: 0; 
  z-index: 999999;
  aspect-ratio: auto;
  display: flex;
  flex-direction: column;
}
.lp-player.lp-fs .lp-video { 
  width: 100%;
  height: 100%; 
  flex: 1;
  min-height: 0;
  aspect-ratio: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* OvenPlayer innere Elemente im Fullscreen */
.lp-player.lp-fs .lp-video > div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lp-player.lp-fs .lp-video video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Fullscreen Bar - über dem Video schwebend */
.lp-player.lp-fs .lp-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0,0,0,0.9));
  padding-bottom: max(20px, env(safe-area-inset-bottom, 0px));
  padding-left: env(safe-area-inset-left, 0px);
  padding-right: env(safe-area-inset-right, 0px);
}

/* Fullscreen + IDLE = versteckt */
.lp-player.lp-fs.lp-idle { cursor: none !important; }
.lp-player.lp-fs.lp-idle .lp-bar { 
  opacity: 0 !important; 
  visibility: hidden !important;
  pointer-events: none;
}

.lp-btn {
  background: rgba(255,255,255,0.15);
  border: none;
  color: #fff;
  min-width: 44px;
  height: 44px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  padding: 0 12px;
}
.lp-btn:hover, .lp-btn:active { background: rgba(255,255,255,0.25); }
.lp-btn svg { width: 22px; height: 22px; fill: currentColor; }
.lp-vol {
  display: flex;
  align-items: center;
  gap: 6px;
}
.lp-vol input {
  width: 80px;
  height: 6px;
  -webkit-appearance: none;
  background: rgba(255,255,255,0.3);
  border-radius: 3px;
  cursor: pointer;
}
.lp-vol input::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
}
.lp-select {
  background: rgba(255,255,255,0.15);
  color: #fff;
  border: none;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  min-height: 44px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' fill='rgba(255,255,255,0.7)' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  padding-right: 30px;
  transition: background 0.2s;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.lp-select:hover, .lp-select:active { background: rgba(255,255,255,0.25); }
.lp-select:focus { outline: 2px solid var(--lp-accent); }
.lp-select option {
  background: #1a202c;
  color: #fff;
  padding: 10px;
}
.lp-src {
  display: flex;
  background: rgba(255,255,255,0.1);
  border-radius: 8px;
  overflow: hidden;
}
.lp-src button {
  background: transparent;
  border: none;
  color: rgba(255,255,255,0.6);
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  min-height: 44px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}
.lp-src button:hover, .lp-src button:active { color: #fff; }
.lp-src button.on { background: var(--lp-accent); color: #fff; }
.lp-live {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #f56565;
  font-size: 13px;
  font-weight: 700;
  padding: 0 8px;
  height: 44px;
  flex-shrink: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  letter-spacing: 1px;
}
.lp-live-dot {
  width: 10px;
  height: 10px;
  background: #f56565;
  border-radius: 50%;
  flex-shrink: 0;
}
.lp-live.lp-playing .lp-live-dot {
  animation: lp-blink 1s infinite;
}
@keyframes lp-blink { 50% { opacity: 0.3; } }

.lp-spacer { flex: 1; }
@media (max-width: 900px) {
  .lp-bar { gap: 6px; }
  .lp-btn { min-width: 40px; height: 40px; padding: 0 10px; }
  .lp-btn svg { width: 20px; height: 20px; }
  .lp-vol input { width: 60px; }
  .lp-select { padding: 8px 26px 8px 10px; font-size: 12px; min-height: 40px; }
  .lp-src button { padding: 8px 12px; font-size: 12px; min-height: 40px; }
  .lp-live { height: 40px; font-size: 12px; }
  .lp-live-dot { width: 9px; height: 9px; }
}
@media (max-width: 700px) {
  .lp-bar { gap: 4px; padding: 40px 10px 10px 10px; }
  .lp-btn { min-width: 36px; height: 36px; padding: 0 8px; }
  .lp-btn svg { width: 18px; height: 18px; }
  .lp-vol input { width: 50px; }
  .lp-select { padding: 6px 24px 6px 8px; font-size: 11px; min-height: 36px; }
  .lp-src button { padding: 6px 10px; font-size: 11px; min-height: 36px; }
  .lp-live { height: 36px; font-size: 11px; padding: 0 4px; }
  .lp-live-dot { width: 8px; height: 8px; }
}
@media (max-width: 550px) {
  .lp-bar { gap: 3px; padding: 35px 8px 8px 8px; justify-content: space-between; }
  .lp-btn { min-width: 32px; height: 32px; padding: 0 6px; }
  .lp-btn svg { width: 16px; height: 16px; }
  .lp-vol { display: none; }
  .lp-select { padding: 5px 22px 5px 6px; font-size: 10px; min-height: 32px; }
  .lp-src button { padding: 5px 8px; font-size: 10px; min-height: 32px; }
  .lp-live { height: 32px; font-size: 10px; padding: 0 2px; }
  .lp-live-dot { width: 7px; height: 7px; }
  .lp-spacer { display: none; }
}
@media (max-width: 400px) {
  .lp-bar { gap: 2px; padding: 30px 6px 6px 6px; justify-content: space-between; }
  .lp-btn { min-width: 28px; height: 28px; padding: 0 4px; }
  .lp-btn svg { width: 14px; height: 14px; }
  .lp-select { padding: 4px 20px 4px 5px; font-size: 9px; min-height: 28px; }
  .lp-src button { padding: 4px 6px; font-size: 9px; min-height: 28px; }
  .lp-live { height: 28px; font-size: 9px; gap: 4px; }
  .lp-live-dot { width: 6px; height: 6px; }
}

/* --- PRE-ROLL VIDEO CSS --- */

/* Container: Aspect Ratio wie beim Hauptvideo */
.lp-preroll {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: #000;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lp-preroll video {
  width: 100%;
  height: 100%;
  aspect-ratio: 16/9;
  object-fit: contain;
  background: #000;
}
/* Native Browser-Controls komplett verstecken */
.lp-preroll video::-webkit-media-controls {
  display: none !important;
}
.lp-preroll video::-webkit-media-controls-enclosure {
  display: none !important;
}
.lp-preroll video::-webkit-media-controls-panel {
  display: none !important;
}

/* Click-to-Play Overlay */
.lp-preroll-play-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10000;
  transition: background 0.3s ease;
}
.lp-preroll-play-overlay:hover {
  background: rgba(0,0,0,0.35);
}
.lp-preroll-play-overlay .play-circle {
  width: 90px;
  height: 90px;
  background: rgba(255,255,255,0.1);
  border: 2px solid rgba(255,255,255,0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.lp-preroll-play-overlay:hover .play-circle {
  background: rgba(255,255,255,0.2);
  border-color: rgba(255,255,255,0.8);
  transform: scale(1.05);
}
.lp-preroll-play-overlay svg {
  width: 40px;
  height: 40px;
  fill: rgba(255,255,255,0.8);
  margin-left: 6px;
}
.lp-preroll-play-overlay:hover svg {
  fill: #fff;
}

/* Control Bar */
.lp-preroll-bar {
  position: absolute;
  bottom: 0; left: 0; right: 0;
  width: 100%;
  background: linear-gradient(transparent, rgba(0,0,0,0.9));
  padding: 40px 15px 15px 15px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;
  z-index: 10001;
  transition: opacity 0.3s ease;
}

.lp-preroll-bar .lp-btn {
  flex-shrink: 0;
}

/* Auto-Hide: Bar KOMPLETT ausblenden */
.lp-preroll.lp-idle .lp-preroll-bar {
  opacity: 0;
  pointer-events: none;
}

.lp-preroll-bar .lp-spacer {
  flex-grow: 1;
  min-width: 10px;
}

/* Fullscreen Button - immer rechts */
.lp-preroll-bar #lp-preroll-fs {
  flex-shrink: 0;
  margin-left: auto;
}

/* Volume Slider */
.lp-preroll-vol-slider {
  width: 80px;
  height: 6px;
  -webkit-appearance: none;
  background: rgba(255,255,255,0.3);
  border-radius: 3px;
  cursor: pointer;
}
.lp-preroll-vol-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
}

/* Skip Button Wrapper - SEPARAT positioniert (unten rechts, neben Fullscreen) */
.lp-preroll-skip-wrap {
  position: absolute;
  bottom: 15px;
  right: 70px;
  z-index: 10002;
  transition: opacity 0.3s ease;
}

/* Auto-Hide: Skip nur LEICHT ausblenden */
.lp-preroll.lp-idle .lp-preroll-skip-wrap {
  opacity: 0.5;
}

/* Skip Button */
.lp-preroll-skip-btn {
  background: rgba(0,0,0,0.6);
  border: 1px solid rgba(255,255,255,0.3);
  color: rgba(255,255,255,0.6);
  padding: 0 16px;
  height: 44px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: default;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Skip Button AKTIV */
.lp-preroll-skip-btn:not(:disabled) {
  background: rgba(255,255,255,0.15);
  border-color: rgba(255,255,255,0.6);
  color: #fff;
  cursor: pointer;
}
.lp-preroll-skip-btn:not(:disabled):hover {
  background: var(--lp-accent);
  border-color: var(--lp-accent);
}

/* --- MEDIA QUERIES (Responsive) --- */
@media (max-width: 900px) {
  .lp-preroll-bar { gap: 8px; }
  .lp-preroll-bar .lp-btn { min-width: 40px; height: 40px; }
  .lp-preroll-bar .lp-btn svg { width: 20px; height: 20px; }
  .lp-preroll-vol-slider { width: 70px; }
  .lp-preroll-skip-wrap { bottom: 14px; right: 62px; }
  .lp-preroll-skip-btn { height: 40px; font-size: 12px; padding: 0 14px; }
  .lp-preroll-play-overlay .play-circle { width: 80px; height: 80px; }
  .lp-preroll-play-overlay svg { width: 35px; height: 35px; margin-left: 5px; }
}

@media (max-width: 700px) {
  .lp-preroll-bar { gap: 6px; padding: 35px 12px 12px 12px; }
  .lp-preroll-bar .lp-btn { min-width: 36px; height: 36px; }
  .lp-preroll-bar .lp-btn svg { width: 18px; height: 18px; }
  .lp-preroll-vol-slider { width: 60px; }
  .lp-preroll-skip-wrap { bottom: 12px; right: 56px; }
  .lp-preroll-skip-btn { height: 36px; font-size: 11px; padding: 0 12px; }
  .lp-preroll-play-overlay .play-circle { width: 70px; height: 70px; }
  .lp-preroll-play-overlay svg { width: 30px; height: 30px; margin-left: 5px; }
}

@media (max-width: 550px) {
  .lp-preroll-bar { padding: 30px 10px 10px 10px; gap: 6px; justify-content: flex-start; }
  .lp-preroll-bar .lp-btn { min-width: 32px; height: 32px; }
  .lp-preroll-bar .lp-btn svg { width: 16px; height: 16px; }
  .lp-preroll-vol-slider { display: none; }
  .lp-preroll-bar .lp-spacer { display: none; }
  #lp-preroll-fs { margin-left: auto; }
  .lp-preroll-skip-wrap { bottom: 10px; right: 50px; }
  .lp-preroll-skip-btn { height: 32px; font-size: 10px; padding: 0 10px; }
  .lp-preroll-play-overlay .play-circle { width: 60px; height: 60px; }
  .lp-preroll-play-overlay svg { width: 25px; height: 25px; margin-left: 4px; }
}

@media (max-width: 400px) {
  .lp-preroll-bar { padding: 25px 8px 8px 8px; gap: 4px; justify-content: flex-start; }
  .lp-preroll-bar .lp-btn { min-width: 28px; height: 28px; }
  .lp-preroll-bar .lp-btn svg { width: 14px; height: 14px; }
  .lp-preroll-vol-slider { display: none; }
  .lp-preroll-bar .lp-spacer { display: none; }
  #lp-preroll-fs { margin-left: auto; }
  .lp-preroll-skip-wrap { bottom: 8px; right: 44px; }
  .lp-preroll-skip-btn { height: 28px; font-size: 9px; padding: 0 8px; }
  .lp-preroll-play-overlay .play-circle { width: 50px; height: 50px; }
  .lp-preroll-play-overlay svg { width: 22px; height: 22px; margin-left: 3px; }
}

/* --- WARTEBILDSCHIRM CSS --- */
.lp-waiting {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: #000;
  z-index: 2000001;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
/* Hintergrundbild - volle Fenstergröße */
.lp-waiting-logo {
  position: absolute;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  animation: lp-fade-in 1s ease forwards;
}
@keyframes lp-fade-in { from { opacity: 0; } to { opacity: 1; } }
/* Overlay über dem Bild für bessere Lesbarkeit */
.lp-waiting-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: radial-gradient(ellipse at center, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.65) 100%);
  z-index: 1;
}
/* Content-Container zentriert über dem Bild */
.lp-waiting-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 100%;
  gap: 14px;
}
.lp-waiting-text {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-shadow: 0 2px 16px rgba(0,0,0,0.9), 0 0 40px rgba(66,153,225,0.15);
  animation: lp-fade-in 0.8s ease 0.3s forwards;
  opacity: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}
.lp-waiting-cd {
  animation: lp-fade-in 0.8s ease 0.5s forwards;
  opacity: 0;
}
.lp-waiting-cd-label {
  color: rgba(255,255,255,0.75);
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 3px;
  text-shadow: 0 1px 8px rgba(0,0,0,0.7);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}
/* Timer horizontal auf einer Zeile */
.lp-waiting-cd-timer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.lp-waiting-cd-timer .lp-cd-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 52px;
  background: rgba(0,0,0,0.45);
  backdrop-filter: blur(8px);
  border-radius: 8px;
  padding: 8px 6px 6px;
}
.lp-waiting-cd-timer .lp-cd-num {
  font-size: 34px;
  font-weight: 700;
  color: #fff;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  text-shadow: 0 2px 12px rgba(66,153,225,0.5);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}
.lp-waiting-cd-timer .lp-cd-lbl {
  font-size: 9px;
  color: rgba(255,255,255,0.55);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-top: 4px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}
.lp-waiting-cd-timer .lp-cd-sep {
  color: rgba(255,255,255,0.3);
  font-size: 22px;
  font-weight: 300;
  margin: 0 2px;
  align-self: flex-start;
  padding-top: 8px;
}
@media (max-width: 700px) {
  .lp-waiting-text { font-size: 15px; }
  .lp-waiting-cd-timer .lp-cd-block { min-width: 44px; padding: 6px 5px 5px; }
  .lp-waiting-cd-timer .lp-cd-num { font-size: 26px; }
  .lp-waiting-cd-timer .lp-cd-sep { font-size: 18px; }
  .lp-waiting-cd-timer .lp-cd-lbl { font-size: 8px; }
}
@media (max-width: 400px) {
  .lp-waiting-text { font-size: 13px; }
  .lp-waiting-cd-label { font-size: 9px; }
  .lp-waiting-cd-timer .lp-cd-block { min-width: 36px; padding: 5px 4px 4px; border-radius: 6px; }
  .lp-waiting-cd-timer .lp-cd-num { font-size: 20px; }
  .lp-waiting-cd-timer .lp-cd-sep { font-size: 14px; padding-top: 5px; }
  .lp-waiting-cd-timer .lp-cd-lbl { font-size: 7px; }
  .lp-waiting-content { gap: 8px; }
}
</style>
